import { useLanguage } from '@/contexts/LanguageContext';
import FadeIn from '@/components/FadeIn';

export default function PropositoSection() {
  const { t } = useLanguage();

  const lines = t.proposito.content.split('\n');

  return (
    <section
      id="proposito"
      data-testid="section-proposito"
      className="min-h-screen flex flex-col justify-center px-8 md:px-16 lg:px-24 py-24 relative"
    >
      {/* Subtle organic shape */}
      <svg
        className="absolute bottom-20 left-0 w-64 h-64 opacity-[0.04] pointer-events-none"
        viewBox="0 0 200 200"
      >
        <ellipse cx="100" cy="100" rx="90" ry="80" fill="#C2A8F7" />
      </svg>

      <FadeIn>
        <h2
          data-testid="proposito-title"
          className="text-3xl md:text-4xl lg:text-5xl font-light text-[#47A2A2] tracking-tight leading-tight mb-12"
        >
          {t.proposito.title}
        </h2>
      </FadeIn>

      <div className="space-y-6 max-w-xl">
        {lines.map((line, index) => (
          <FadeIn key={index} delay={0.2 * (index + 1)}>
            <p
              data-testid={`proposito-line-${index}`}
              className="text-base md:text-lg font-light text-[#333333]/90 leading-relaxed"
            >
              {line}
            </p>
          </FadeIn>
        ))}
      </div>
    </section>
  );
}
